import { withStyles } from "@material-ui/core/styles";
import FilterPoints from "./FilterPoints";
import styles from "./styles";

export default withStyles(styles)(FilterPoints);
